module.exports = __webpack_public_path__ + "media/images/tailwind/foot1-bg-b7ca086cf718e3e2284bbd5466b17e17.png";